// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Markets$Showside from "../types/Markets.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Location$Showside from "../utils/Location.bs.js";
import * as URLUtils$Showside from "../utils/URLUtils.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SWRScrapeCache$Showside from "../utils/SWRScrapeCache.bs.js";
import * as IntegrationUtils$Showside from "../utils/IntegrationUtils.bs.js";
import * as ShopifyAnalytics$Showside from "../utils/ShopifyAnalytics.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductDetailsPage$Showside from "../pages/ProductDetailsPage.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as MiniCartDrawer_Lazy$Showside from "../components/MiniCartDrawer_Lazy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
function useUrlTransformer(enabledOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  ConfigurationProvider$Showside.use(undefined);
  var match = LocationConfig$Showside.use(undefined);
  var setUrlTransformer = match.setUrlTransformer;
  var namespace = match.namespace;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var smartnavApiHost = match$1.smartnavApiHost;
  var match$2 = Markets$Showside.getValues(match$1.market);
  var country = match$2.country;
  var currency = match$2.currency;
  var urlTransformer = function (loc, baseUrl) {
    var productId = Belt_Option.flatMap(loc.quickNav, function (nav) {
      return nav.productId;
    });
    var variantId = Belt_Option.flatMap(loc.quickNav, function (nav) {
      return nav.variantId;
    });
    var product = Belt_Option.flatMap(productId, function (pi) {
      return SWRScrapeCache$Showside.getProductById(smartnavApiHost, currency, country, pi);
    });
    var variant = Belt_Option.flatMap(variantId, function (vi) {
      return Belt_Option.flatMap(product, function (p) {
        return Belt_Array.getBy(Product$Showside.getAllVariants(p), function (v) {
          return v.id === vi;
        });
      });
    });
    var newUrl = variant !== undefined ? Belt_Option.flatMap(variant.link, URLUtils$Showside.maybeMakeUrl) : product !== undefined ? Belt_Option.flatMap(product.link, URLUtils$Showside.maybeMakeUrl) : undefined;
    return Belt_Option.map(Belt_Option.map(Belt_Option.keep(newUrl, function (newUrl) {
      return newUrl.hostname === baseUrl.hostname;
    }), function (newUrl) {
      newUrl.protocol = baseUrl.protocol;
      return newUrl;
    }), function (newUrl) {
      return new URL(Location$Showside.toBaseUrl(namespace, newUrl.href));
    });
  };
  React.useEffect(function () {
    if (enabled) {
      Curry._1(setUrlTransformer, function (param) {
        return urlTransformer;
      });
    }
    return function (param) {
      Curry._1(setUrlTransformer, function (param) {});
    };
  }, [namespace, enabled]);
}
function PDPApp$Content(Props) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var shopifyProductId = ShopifyAnalytics$Showside.getProductPageProductId(undefined);
  var productId = Belt_Option.orElse(match.anyProductId, shopifyProductId);
  useUrlTransformer(ShopifyAnalytics$Showside.isProductPage(undefined), undefined);
  if (productId !== undefined) {
    return React.createElement(ProductDetailsPage$Showside.make, {
      productId: productId
    });
  } else {
    return null;
  }
}
PDPApp$Content.displayName = "PDPApp.Content";
var Content = {
  make: PDPApp$Content
};
function PDPApp(Props) {
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  var match = RouterProvider$Showside.useRouter(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var config = match$1.config;
  var match$2 = LocationConfig$Showside.use(undefined);
  var namespace = match$2.namespace;
  var pageOnlyHasPDP = IntegrationUtils$Showside.countBottombarElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countInlineElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countLauncherElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countSectionElementsByNamespace(namespace) === 0;
  var tmp = {
    config: config,
    embedType: embedType,
    children: null
  };
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  var tmp$1;
  var tmp$2 = match.route;
  tmp$1 = typeof tmp$2 === "number" || !(tmp$2.TAG === /* QuickView */3 && pageOnlyHasPDP) ? null : React.createElement(QuickViewOverlay_Lazy$Showside.make, {});
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "pdp",
    portal: false,
    children: React.createElement(EntrypointCallbacks$Showside.make, tmp, tmp$1, React.createElement(PDPApp$Content, {}), React.createElement(ConditionalRender$Showside.When.make, {
      condition: config.settings.cart,
      children: React.createElement(MiniCartDrawer_Lazy$Showside.make, {})
    }))
  });
}
PDPApp.displayName = "PDPApp";
var make = PDPApp;
var $$default = PDPApp;
export { useUrlTransformer, Content, make, $$default, $$default as default };
/* react Not a pure module */